import { useQuery } from '@tanstack/react-query';
import { OilStoreService } from 'services/openapi';
import { OilStoreQueryKeys } from './constants';

interface UseGetOilStoreTransactionsQueryParams {
  transactionStatus:
    | 'Tất cả'
    | 'Thành công'
    | 'Thất bại'
    | 'Đã hủy'
    | 'Đang chờ hủy'
    | 'Đang xử lý';
  fromTime: string;
  toTime: string;
  transactionCode?: string;
  transactionType?: 'Tất cả' | 'Thanh toán' | 'Nhận thanh toán';
  fromUserSearchString?: string;
  toUserSearchString?: string;
  searchDetailContent?: string;
  page?: string;
  pageSize?: string;
  userMerchantId?: string;
  bankAccountNumber?: string;
  enabled?: boolean;
  fetchData?: number;
}

export const useGetOilStoreTransactionsQuery = (
  params: UseGetOilStoreTransactionsQueryParams,
) => {
  const {
    transactionStatus,
    fromTime,
    toTime,
    transactionCode,
    transactionType,
    fromUserSearchString,
    toUserSearchString,
    searchDetailContent,
    page = '1',
    pageSize = '10',
    userMerchantId,
    bankAccountNumber,
    enabled = true,
    fetchData,
  } = params;

  return useQuery({
    queryKey: [
      OilStoreQueryKeys.GET_OIL_STORE_TRANSACTIONS,
      {
        transactionStatus,
        fromTime,
        toTime,
        transactionCode,
        transactionType,
        fromUserSearchString,
        toUserSearchString,
        searchDetailContent,
        page,
        pageSize,
        userMerchantId,
        bankAccountNumber,
        // TableListData increments this on each search, including unchanged filters.
        fetchData,
      },
    ],
    queryFn: () =>
      OilStoreService.oilStoreControllerGetListOilStoreTrans(
        transactionStatus,
        fromTime,
        toTime,
        transactionCode,
        transactionType,
        fromUserSearchString,
        toUserSearchString,
        searchDetailContent,
        page,
        pageSize,
        userMerchantId,
        bankAccountNumber,
      ),
    retry: 0,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  });
};
